<template lang="pug">
.entity-display.px-5(:class="{'background': background}")
  v-row(v-if="showHeader || edit || close")
    v-col.d-flex.align-center(v-if="showHeader")
      h5.entity-display_title.primary--text {{ getLabel.replace(/_/g, " ") }}
    v-col.entity-display_actions.justify-end.d-flex
      g-btn.mr-3.primary--text(
        v-if="edit",
        icon,
        small,
        @click="$emit('edit')",
      )
        v-icon mdi-pencil
      g-btn.primary--text(
        v-if="close"
        icon,
        small,
        @click="$emit('close')",
      )
        v-icon mdi-close
  v-row(v-if="isValidValue")
    v-col.pt-0.entity-display_form(v-for="column in columnsNumber")
      .d-flex.pa-1(v-for="key in getArrayKeys(column)")
        slot(name="item", v-bind="{ showKey, keyClass, key }")
          div(v-if="showKey", :class="keyClass") {{ keyTransform(key) }}:
        .px-1.overflow-auto(:class="valueClass") {{ selectedValue[key] }}
</template>

<style lang="scss" scoped>
.entity-display.background.px-5 {
  border: 0.8px solid #3200E6 !important;
  border-radius: 5px;
}
</style>

<script>
export default {
  props: {
    close: {
      type: Boolean,
      default: true,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    entity: null,
    value: {
      type: Object,
      default: () => ({}),
    },
    errorStyle: {
      type: Boolean,
      default: false,
    },
    keyClass: {
      type: String,
      default: 'h8',
    },
    valueClass: {
      type: String,
      default: 'h7',
    },
    background: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
    },
    keyFunction: {
      type: Boolean,
      default: true,
    },
    showKey: {
      type: Boolean,
      default: true
    },
    customHeader: {
      type: String,
      default: null
    },
    columnsNumber: {
      type: Number,
      default: 2,
    },
  },
  data: () => ({}),
  methods: {
    keyTransform(val) {
      if (!this.keyFunction) return val;
      return this.$camelToString(val);
    },
    getArrayKeys(columnNumber) {
      return this.chunkedKeys[columnNumber - 1] || [];
    },
  },
  computed: {
    entityName() {
      return _.get(this.entity, 'name');
    },
    getLabel() {
      if (this.customHeader) return this.customHeader;
      const translatedDetails = this.$t('entityDisplay.details');

      const entityLabel = this.$camelToString(this.$displayName(this.entityName));
      const translatedEntity = this.$tCheckC(`${this.entityName}._name`, entityLabel, 1);

      return !_.isEmpty(this.entity) ? `${translatedEntity} ${translatedDetails}` : translatedDetails;
    },
    isValidValue() {
      return !_.isEmpty(this.value);
    },
    // When using an object that only has array values, we want to flatten the errors into multiple entries.
    // EX: fieldName: ['FOO', 'BAR'] -> fieldName 0: 'FOO' , fieldName 1: 'BAR'
    // In case of only 1 element, then the index is not appended.
    flatValue() {
      return _.chain(this.value).reduce((res, val, key) => {
        if (!val || val.length === 0) return res;
        if (val.length < 2) res[key] = val[0];
        else {
          _.forEach(val, (value, index) => {
            res[`${key} ${index}`] = value;
          });
        }
        return res;
      }, {}).value();
    },
    selectedValue() {
      return this.errorStyle ? this.flatValue : this.value;
    },
    keysValue() {
      return _.keys(this.selectedValue);
    },
    chunkedKeys() {
      return _.chunk(this.keysValue, _.ceil(this.keysValue.length / this.columnsNumber));
    },
  },
}
</script>
